import {
  TOGGLE_INNERSIDEBAR,
  SET_INNERSIDEBAR,
  UNSET_INNERSIDEBAR,
  DISABLE_INNERSIDEBAR,
  ENABLE_INNERSIDEBAR,
} from './../../mutation-types';

export default {
  [TOGGLE_INNERSIDEBAR](state, status = null) {
    state.innerSidebarState = status !== null && status !== undefined ?
                              status :
                              !state.innerSidebarState;
  },

  [DISABLE_INNERSIDEBAR](state) {
    state.innerSidebarDisabled = true;
  },

  [ENABLE_INNERSIDEBAR](state) {
    state.innerSidebarDisabled = false;
  },

  [SET_INNERSIDEBAR](state, content) {
    state.innerSidebar = content;
  },

  [UNSET_INNERSIDEBAR](state) {
    state.innerSidebar = [];
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/sidebar/mutations.js